const NX_ENV = process.env['NX_ENV'];

// applications hosting the unisphere-plg widget (nvp1/nvq2) - the only origins allowed to hand over a ks
const KALTURA_ORIGIN_REGEX = /^https:\/\/([a-z0-9-]+\.)*kaltura\.(com|ai)$/;
// kaltura.vercel.app and vercel deployments
const KALTURA_VERCEL_ORIGIN_REGEX = /^https:\/\/([a-z0-9-]+-)?kaltura\.vercel\.app$/;
const LOCALHOST_ORIGIN_REGEX = /^https?:\/\/localhost(:\d+)?$/;

export const isTrustedHostOrigin = (origin: string) =>
  KALTURA_ORIGIN_REGEX.test(origin) ||
  KALTURA_VERCEL_ORIGIN_REGEX.test(origin) ||
  (NX_ENV !== 'production' && LOCALHOST_ORIGIN_REGEX.test(origin));
